<template>
  <page-outline :title="$t('injection_tab.test_case_details')" v-if="testCaseDetailsToggle">
    <template slot="pageContent">
      <div slot="pageContent">
        <b-container fluid>
          <div class="flex h-screen" :key="updateDetailsPanel">
            <b-row class="mb-5">
              <b-col sm="2">
                <b-button class="btnBack mx-2 px-2 py-1 w-100" variant="secondary" @click="closeTestCaseDetails(testCase)">
                  <i class="fas fa-arrow-left" style="font-size: 15px;"></i>
                  {{ $t('injection_tab.back') }}
                </b-button>
              </b-col>
              <b-col sm="2">
                <b-button class="btnRefresh mx-2 px-2 py-1 w-100" variant="secondary" @click="refreshDetails(testCase)">
                  <i class="fas fa-rotate-right" style="font-size: 15px;"></i>
                  {{ $t('injection_tab.refresh') }}
                </b-button>
              </b-col>
              <b-col sm="">
              </b-col>
              <b-col sm="2" class="">
                <b-button class="btnAddDataset ml-2 px-2 py-1  w-100" variant="secondary" @click="addDataset(testCase)">
                  <i class="fas fa-plus-circle" style="font-size: 15px;"></i>
                  {{ $t('injection_tab.add_dataset') }}
                </b-button>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="12">
                <form-accordion :title="$t('injection_tab.test_case.details')" :isTitleUpperCase="false">
                  <b-row class="justify-content-start">
                    <b-col sm="1">
                      <p class="mb-0"><strong>{{ $t('account_tb.id') }}</strong></p>
                      <p>{{ testCase.id }}</p>
                    </b-col>
                    <b-col>
                      <p class="mb-0"><strong>{{ $t('injection_tab.test_case.case_summary') }}</strong></p>
                      <p>{{ $t(`toolbox.resp_summary_case.${testCase.caseSummary}`) }}</p>
                    </b-col>
                    <b-col>
                      <p class="mb-0"><strong>{{ $t('injection_tab.test_case.response_status') }}</strong></p>
                      <p>{{ testCase.expectedResult }}</p>
                    </b-col>
                    <b-col>
                      <p class="mb-0"><strong>{{ $t('injection_tab.test_case.date_last_test') }}</strong></p>
                      <p>{{ testCase.lastExecDate | formatDateTime }}</p>
                    </b-col>
                    <b-col>
                      <p class="mb-0"><strong>{{ $t('injection_tab.test_case.number_req_resp') }}</strong></p>
                      <p>{{ testCase.nbOK }} / {{ testCase.datasets.length }}</p>
                    </b-col>
                    <b-col>
                      <p class="mb-0"><strong>{{ $t('injection_tab.last_status') }}</strong></p>
                      <p><i v-if="testCase.AllStatusOk === '2' || testCase.AllStatusOk === 'OK'" title="OK" class="fas fa-check bg-success text-white rounded-circle d-flex align-items-center justify-content-center"
                         style="width: 20px; height: 20px;">
                      </i>
                      <i v-else-if="testCase.AllStatusOk === '0' || testCase.AllStatusOk === 'KO'" title="KO" class="fas fa-times bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
                         style="width: 20px; height: 20px;">
                      </i>
                      <i v-else-if="testCase.AllStatusOk === '3'" title="Missing configuration" class="fas fa-file-alt" style="color: gray; font-size: 20px;"></i>
                      <i v-else-if="testCase.AllStatusOk === '4'" title="Pending" class="fas fa-hourglass-half" style="color: gray; font-size: 20px;"></i>
                      <i v-else-if="testCase.AllStatusOk === '5' || testCase.AllStatusOk === 'GRIS'" title="Not tested yet" class="fas fa-minus bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center"
                         style="width: 20px; height: 20px;">
                      </i>
                      <span v-else class="fs-21px"><strong>{{ testCase.testCaseResult }}</strong></span></p>

                    </b-col>
                  </b-row>
                  <b-row class="justify-content-start">
                    <b-col>
                      <p class="mb-0"><strong>{{ $t('injection_tab.test_case.case_description') }}</strong></p>
                      <p>{{ $t(`toolbox.resp_description_case.${testCase.description}`) }}</p>
                    </b-col>
                  </b-row>
                </form-accordion>
              </b-col>
            </b-row>

            <hr class="mb-4">

            <b-row v-for="(dataset, index) in testCaseDatasets" :key="dataset.id" class="pb-3" v-if="testCaseDatasets.length > 0">
              <b-col sm="12">
                <form-accordion :title="buildDatasetName(index, false)" :isTitleUpperCase="false">
                  <form-accordion :title="$t('injection_tab.data_request')" :isTitleUpperCase="false" class="ml-3">
                    <template v-if="testCase.datasetsRequirements.length">
                      <b-row class="justify-content-start ml-1">
                        <b-col sm="3">
                          <p class="mb-0"><strong>{{ $t('account_tb.test_case_id') }}</strong></p>
                          <p>{{ dataset.id }}</p>
                        </b-col>
                        <b-col sm="3">
                          <div class="d-flex align-items-center justify-content-start mb-0">
                            <p class="mb-0">
                              <strong>{{ $t('injection_tab.test_case.case_description') }}</strong>
                            </p>
                          </div>
                          <div class="mt-2 pt-0">
                            <form-write-group-label-input
                              v-model="dataset.descriptionCase"
                              :placeholderValue="'Description'">
                            </form-write-group-label-input>
                          </div>
                        </b-col>
                        <b-col sm="3">
                          <p class="mb-0"><strong>{{ $t('injection_tab.last_execution') }}</strong></p>
                          <p v-if="dataset.lastExecution">{{ dataset.lastExecution | formatDateTime }}</p>
                          <p v-else>-</p>
                        </b-col>
                        <b-col sm="3">
                          <p class="mb-3"><strong>{{ $t('injection_tab.last_status') }}</strong></p>
                          <i v-if="dataset.AllStatusOk === '2'" title="OK" class="fas fa-check bg-success text-white"
                             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                          </i>
                          <i v-else-if="dataset.AllStatusOk === '0'" title="KO" class="fas fa-times bg-danger text-white"
                             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                          </i>
                          <i v-else-if="dataset.AllStatusOk === '4'" title="Pending" class="fas fa-hourglass-half" style="color: gray; font-size: 20px;"></i>
                          <i v-else-if="dataset.AllStatusOk === '3'" title="Missing configuration" class="fas fa-file-alt" style="color: gray; font-size: 20px;"></i>
                          <i v-else-if="!dataset.AllStatusOk || dataset.AllStatusOk === '5'" title="Not tested yet" class="fas fa-minus bg-secondary text-white"
                             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;width:20px;height:20px;">
                          </i>
                          <p v-else>{{ dataset.resultTest }}</p>
                        </b-col>

                        <template v-for="(requirement, index) in testCase.datasetsRequirementsRequest" v-if="testCase.datasetsRequirementsRequest && testCase.datasetsRequirementsRequest.length">

                          <b-col sm="3" class="form-group" v-if="dataset.datas.some(data => data.field === requirement.field && data.messageType === requirement.messageType) && requirement.messageType === '0'">
                            <template>
                              <div v-if="requirement.fieldEditable !== '1'">
                                <p class="mb-0"><strong>{{ requirement.field }}</strong></p>
                                <p>{{ dataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).fieldValue }}</p>
                              </div>
                              <form-write-group-label-input v-model="dataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).tmpFieldValue"
                                :inputLabel="requirement.field" :placeholderValue="requirement.field" v-else>
                              </form-write-group-label-input>
                            </template>
                          </b-col>
                        </template>
                      </b-row>
                      <b-table responsive
                        class="table table-striped"
                        thead-class="d-none"
                        :fields="fieldsDatasetRequirements(testCase.datasetsRequirementsRequest)"
                        :items="itemsDatasetRequirements(testCase.datasetsRequirementsRequest)">
                      </b-table>
                    </template>
                  </form-accordion>
                  <form-accordion :title="$t('injection_tab.response')" :isTitleUpperCase="false" class="ml-3" v-if="testCase.datasetsRequirementsResponse && testCase.datasetsRequirementsResponse.length">
                    <b-row class="justify-content-start ml-3">
                      <template v-for="(requirement, index) in testCase.datasetsRequirementsResponse">

                        <b-col sm="3" class="form-group" v-if="dataset.datas.some(data => data.field === requirement.field && data.messageType === requirement.messageType) && requirement.messageType === '1'">
                          <template>
                            <div v-if="requirement.fieldEditable !== '1'">
                              <p class="mb-0"><strong>{{ requirement.field }}</strong></p>
                              <p>{{ dataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).fieldValue }}</p>
                            </div>
                            <form-write-group-label-input v-model="dataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).tmpFieldValue"
                              :inputLabel="requirement.field" :placeholderValue="requirement.field" v-else>
                            </form-write-group-label-input>
                          </template>
                        </b-col>

                        <b-row v-if="((index + 1) % 4 === 0) || index === testCase.datasetsRequirements.filter(req => req.fieldEditable === 1).length - 1"></b-row>
                      </template>
                    </b-row>
                  </form-accordion>
                  <form-accordion :title="$t('injection_tab.history')" :isTitleUpperCase="false" class="ml-3">
                    <b-row class="mb-3 justify-content-start ml-3 mr-3">
                      <b-table responsive
                        class="table table-striped"
                        thead-class="d-none"
                        :current-page="pageCounter"
                        :fields="fieldsHistoryTab"
                        :items="dataset.history"
                        :per-page="paginationObject.maxResults"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDir"
                        sort-by="executionDate"
                        :sort-desc="false">
                        <template #cell(testCaseStatus)="data">
                          <i v-if="data.value === '2'" title="OK" class="fas fa-check bg-success text-white"
                             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                          </i>
                          <i v-else-if="data.value === '0'" title="KO" class="fas fa-times bg-danger text-white"
                             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                          </i>
                          <i v-else-if="data.value === '4'" title="Pending" class="fas fa-hourglass-half" style="color: gray; font-size: 20px;"></i>
                          <i v-else-if="data.value === '3'" title="Missing configuration" class="fas fa-file-alt" style="color: gray; font-size: 20px;"></i>
                          <i v-else-if="data.value === '5'" title="Not tested yet" class="fas fa-minus bg-secondary text-white"
                             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                          </i>
                          <p v-else>{{ data.value }}</p>
                        </template>
                        <template #cell(testCaseStatusCode)="data">
                          {{ data.value ? ($t('toolbox.error-status.' + data.value) !== 'toolbox.error-status.' + data.value ? $t('toolbox.error-status.' + data.value) : data.value) : '-' }}
                        </template>
                        <template #cell(executionDate)="data">
                          {{ parseHistoryDate(data.value) }}
                        </template>

                        <template #cell(buttons)="data">
                          <i title="Open" class="fas fa-eye px-1 cursor-pointer" v-if="data.item.testCaseStatus != '3'"  style="color: var(--actionButtonColorBlue); font-size: 15px;" @click="openHistory(data.item.idVopMessageOrigin, data.item.testCaseStatus, 'see')"></i>
                          <i title="Download" class="fas fa-download px-1 cursor-pointer" v-if="data.item.testCaseStatus != '3'"  style="color: var(--actionButtonColorBlue); font-size: 15px;" @click="openHistory(data.item.idVopMessageOrigin, data.item.testCaseStatus, 'download')"></i>
                        </template>
                      </b-table>
                    </b-row>
                  </form-accordion>

                  <b-row class="pb-3 justify-content-center">
                    <b-col sm="2" v-if="$engine.rights.rightIs('DataSetResponder_editer', true)">
                      <b-button class="btnSaveDataset mx-2 px-2 py-1 w-100" variant="secondary" @click="putDataset(dataset, testCase)">{{ $t('injection_tab.save_data') }}</b-button>
                    </b-col>
                    <b-col sm="2" v-if="$engine.rights.rightIs('ExecutionResponder_add', true)">
                      <b-button class="btnSend mx-2 px-2 py-1 w-100" variant="primary" @click="runDataset(dataset)">{{ $t('injection_tab.send_again') }}</b-button>
                    </b-col>
                    <b-col sm="2" v-if="$engine.rights.rightIs('DataSetResponder_supprimer', true) && testCaseDatasets.length > 1">
                      <b-button class="btnSend mx-2 px-2 py-1 w-100" variant="primary" @click="deleteDataset(dataset)">{{ $t('common.del_label') }}</b-button>
                    </b-col>
                  </b-row>
                </form-accordion>
                <hr>
              </b-col>
            </b-row>

            <!-- NEW DATASETS NOT ALREADY SAVED IN DATABASE -->
            <b-row v-for="(tmpDataset, index) in testCase.tmpDatasets" :key="tmpDataset.id" class="pb-3" v-if="testCase.tmpDatasets.length > 0">
              <b-col sm="12">
                <form-accordion :title="buildDatasetName(index, true)" :isTitleUpperCase="false">
                  <form-accordion :title="$t('injection_tab.data_request')" :isTitleUpperCase="false" class="ml-3"  v-if="testCase.datasetsRequirements.length">
                    <template>
                      <b-row class="justify-content-start ml-1">
                        <b-col sm="3" v-if="tmpDataset.id">
                        </b-col>
                        <b-col sm="3">
                          <div class="d-flex align-items-center justify-content-start mb-0">
                            <p class="mb-0">
                              <strong>{{ $t('injection_tab.test_case.case_description') }}</strong>
                            </p>
                          </div>
                          <div class="mt-2 pt-0">
                            <form-write-group-label-input
                              v-model="tmpDataset.descriptionCase"
                              :placeholderValue="'Description'">
                            </form-write-group-label-input>
                          </div>
                        </b-col>
                        <b-col sm="3">
                          <p class="mb-0"><strong>{{ $t('injection_tab.last_execution') }}</strong></p>
                          <p>{{ tmpDataset.lastExecution }}</p>
                        </b-col>
                        <b-col sm="3">
                          <p class="mb-3"><strong>{{ $t('injection_tab.last_status') }}</strong></p>
                          <i v-if="tmpDataset.resultTest === '2'" title="OK" class="fas fa-check bg-success text-white"
                             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                          </i>
                          <i v-else-if="tmpDataset.resultTest === '0'" title="KO" class="fas fa-times bg-danger text-white"
                             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                          </i>
                          <i v-else-if="tmpDataset.resultTest === '4'" title="Pending" class="fas fa-hourglass-half" style="color: gray; font-size: 20px;"></i>
                          <i v-else-if="tmpDataset.resultTest === '3'" title="Missing configuration" class="fas fa-file-alt" style="color: gray; font-size: 20px;"></i>
                          <i v-else-if="tmpDataset.resultTest === '5'" title="Not tested yet" class="fas fa-minus bg-secondary text-white"
                             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                          </i>
                          <p v-else>{{ tmpDataset.resultTest }}</p>
                        </b-col>

                        <template v-for="(requirement, index) in testCase.datasetsRequirementsRequest">

                          <b-col sm="3" class="form-group" v-if="tmpDataset.datas.some(data => data.field === requirement.field && data.messageType === requirement.messageType) && requirement.messageType === '0'">
                            <template>
                              <div v-if="requirement.fieldEditable !== '1'">
                                <p class="mb-0"><strong>{{ requirement.field }}</strong></p>
                                <p>{{ tmpDataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).fieldValue }}</p>
                              </div>
                              <form-write-group-label-input v-model="tmpDataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).tmpFieldValue"
                                :inputLabel="requirement.field" :placeholderValue="requirement.field" v-else>
                              </form-write-group-label-input>
                            </template>
                          </b-col>

                          <b-row v-if="((index + 1) % 4 === 0) || index === testCase.datasetsRequirements.filter(req => req.fieldEditable === 1).length - 1"></b-row>
                        </template>
                      </b-row>
                    </template>
                  </form-accordion>
                  <form-accordion :title="$t('injection_tab.response')" :isTitleUpperCase="false" class="ml-3" v-if="testCase.datasetsRequirementsResponse && testCase.datasetsRequirementsResponse.length">
                    <b-row class="justify-content-start ml-3">
                      <template v-for="(requirement, index) in testCase.datasetsRequirementsResponse">

                        <b-col sm="3" class="form-group" v-if="tmpDataset.datas.some(data => data.field === requirement.field && data.messageType === requirement.messageType) && requirement.messageType === '1'">
                          <template>
                            <div v-if="requirement.fieldEditable !== '1'">
                              <p class="mb-0"><strong>{{ requirement.field }}</strong></p>
                              <p>{{ tmpDataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).fieldValue }}</p>
                            </div>
                            <form-write-group-label-input v-model="tmpDataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).tmpFieldValue"
                              :inputLabel="requirement.field" :placeholderValue="requirement.field" v-else>
                            </form-write-group-label-input>
                          </template>
                        </b-col>

                        <b-row v-if="((index + 1) % 4 === 0) || index === testCase.datasetsRequirements.filter(req => req.fieldEditable === 1).length - 1"></b-row>
                      </template>
                    </b-row>
                  </form-accordion>

                  <b-row class="pb-3 justify-content-center">
                    <b-col sm="2" v-if="$engine.rights.rightIs('DataSetResponder_ajouter', true)">
                      <b-button class="btnSaveDataset mx-2 px-2 py-1 w-100" variant="secondary" @click="postDataset(tmpDataset, testCase, index)">{{ $t('injection_tab.save_data') }}</b-button>
                    </b-col>
                    <b-col sm="2" v-if="$engine.rights.rightIs('DataSetResponder_supprimer', true)">
                      <b-button class="btnSend mx-2 px-2 py-1 w-100" variant="primary" @click="deleteDataset(tmpDataset, index)">{{ $t('common.del_label') }}</b-button>
                    </b-col>
                  </b-row>
                </form-accordion>
                <hr>
              </b-col>
            </b-row>

            <b-row class="pb-3 justify-content-center">
              <b-col sm="2" v-if="$engine.rights.rightIs('ExecutionResponder_add', true)">
                <b-button class="btnSendAgain mx-2 px-2 py-1 w-100" variant="primary" @click="runTestCase(testCase)">{{ $t('injection_tab.send_again_test_case') }}</b-button>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
    </template>
  </page-outline>
  <page-outline :title="$t('Webheader.testCaseRequestedList')" v-else>
    <template slot="pageContent">
      <div slot="pageContent">
        <b-container fluid class="rounded shadow-sm">
          <div class="flex h-screen" :key="updateListPanel">
            <div class="mx-3">
              <b-row class="mb-2 justify-content-end">
                <b-col sm="2" class="form-group d-flex flex-column">
                  <b-button class="btnImport mx-2 px-2 py-1 w-auto" variant="secondary" for="fileInput">
                    <i class="fa-light fa-plus "></i>
                    <label for="fileInput" style="color:var(--actionTextColorWhite)">{{ $t('injection_tab.import_test_case') }}</label>
                  </b-button>
                  <input type="file" id="fileInput" @change="importTestCases" accept=".csv" style="display: none;" />
                </b-col>
                <b-col sm="2" class="form-group d-flex flex-column">
                  <b-button class="btnFilter mx-2 px-2 py-1 w-auto" variant="secondary" @click="toggleFilter()">
                    <i v-if="filterToggle" class="fa-light fa-minus"></i>
                    <i v-else class="fa-light fa-plus"></i>
                    {{ $t('injection_tab.filters') }}
                  </b-button>
                </b-col>
                <b-col cols="4" lg="2" xl="2" class="form-group d-flex flex-column">
                  <b-button class="btnFilter"
                    @click="getTestsCases()">
                    <i class="fa-light fa-rotate-right"></i>
                    {{ $t('common.rfrsh') }}
                  </b-button>
                </b-col>
              </b-row>
              <hr class="my-3" v-if="filterToggle">
              <b-row class="mb-3 align-items-end" no-gutters v-if="filterToggle">
                <b-col cols="2">
                  <div>
                    <span class="filter-item-title d-block mb-1">{{ $t('injection_tab.select_t_c_result') }}</span>
                    <select v-model="filterForm.caseStatus" class="filter-item-content w-100" style="padding:0.5rem;">
                      <option value="" selected>----------</option>
                      <option value="2">{{ $t('account_tb.status.OK')}}</option>
                      <option value="KO">{{ $t('account_tb.status.KO')}}</option>
                      <option value="4">{{ $t('account_tb.status.RUN')}}</option>
                      <option value="3">{{ $t('account_tb.status.CONF_NOT_FOUND')}}</option>
                      <option value="GRIS">{{ $t('account_tb.status.NULL')}}</option>
                    </select>
                  </div>
                </b-col>
                <b-col cols="2">
                  <div>
                    <span class="filter-item-title d-block mb-1">{{ $t('injection_tab.select_t_c_status') }}</span>
                    <select v-model="filterForm.testCaseResult" class="filter-item-content w-100" style="padding:0.5rem;">
                      <option value="" selected>----------</option>
                      <option v-for="result in uniqueExpectedResults" :key="result" :value="result">
                        {{ result }}
                      </option>
                    </select>
                  </div>
                </b-col>
                <b-col cols="2" class="filter-item">
                  <input-filter-dropdown-list
                      @update-val="updateVal"
                      :reset-trigger="resetSignal"
                      :label="$t('toolbox.filtre_case_summary')"
                      :item-list="AllRowName"
                      trad-path="toolbox.resp_summary_case"
                  ></input-filter-dropdown-list>
                </b-col>
                <b-col cols="2">
                  <div>
                    <span class="filter-item-title d-block mb-1">{{ $t('injection_tab.date_begin') }}</span>
                    <datetime-picker-custom format="YYYY-MM-DD HH:mm:ss" periodFull
                      id="filter-datebegin"
                      class="mr-3"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': filterForm.dateBegin}"
                      customInputParentClass="filter-item-content"
                      customInputClass="w-100"
                      :maxLength="19"
                      :placeholderValue="$t('common.datetime_picker_empty_date')"
                      inputIcon="fa-solid fa-calendar"
                      v-model="filterForm.dateBegin">
                    </datetime-picker-custom>
                  </div>
                </b-col>
                <b-col cols="2">
                  <div>
                    <span class="filter-item-title d-block mb-1">{{ $t('injection_tab.date_end') }}</span>
                    <datetime-picker-custom format="YYYY-MM-DD HH:mm:ss" periodFull
                      id="filter-datebegin"
                      class="mr-3"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': filterForm.dateEnd}"
                      customInputParentClass="filter-item-content"
                      customInputClass="w-100"
                      :maxLength="19"
                      :placeholderValue="$t('common.datetime_picker_empty_date')"
                      inputIcon="fa-solid fa-calendar"
                      v-model="filterForm.dateEnd">
                    </datetime-picker-custom>
                  </div>
                </b-col>
                <b-col cols="2">
                  <b-col class="d-flex justify-content-end align-items-center mt-4 px-0">
                    <b-button class="btnResetFilter mr-2 px-3 py-1 w-auto col-5" variant="secondary" @click="resetFilterForm()">{{ $t('injection_tab.reset') }}</b-button>
                    <b-button class="btnDoFiler px-3 py-1 w-auto col-5" variant="primary" @click="applyFilter()">{{ $t('injection_tab.search') }}</b-button>
                  </b-col>
                </b-col>
              </b-row>
              <hr class="my-3">
              <b-row class="mb-3 justify-content-center" v-if="activateSpinner">
                <spinner></spinner>
              </b-row>
              <b-row class="mb-3 justify-content-start" v-else-if="testsCasesFiltered.length > 0">
                <b-table responsive hover
                  class="table table-striped cursor-pointer"
                  :current-page="pageCounter"
                  :fields="fieldsTestsCasesTab"
                  :items="testsCasesFiltered"
                  :per-page="paginationObject.maxResults"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDir"
                  @head-clicked="sortTable"
                  @row-clicked="openTestCaseDetails"
                >
                  <template #head(select)>
                    <input type="checkbox" v-model="selectAll" @change="toggleAllRows" class="checkbox-lg">
                  </template>

                  <template #cell(caseSummary)="data">
                    <div> {{ $t(`toolbox.resp_summary_case.${data.item.caseSummary}`) }} </div>
                  </template>

                  <template #cell(select)="data">
                    <input type="checkbox" v-model="selectedTestsCases" :value="data.item.id" class="checkbox-lg">
                  </template>

                  <template #cell(AllStatusOk)="data">
                    <i v-if="(data.value === '2' || data.item.AllStatusOk == 'OK')" title="OK" class="fas fa-check bg-success text-white"
                       style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                    <i v-else-if="(data.value === '0' || data.item.AllStatusOk == 'KO')" title="KO" class="fas fa-times bg-danger text-white"
                       style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                    <i v-else-if="data.value === '4'" title="Pending" class="fas fa-hourglass-half" style="color: gray; font-size: 20px;"></i>
                    <i v-else-if="data.value === '3'" title="Missing configuration" class="fas fa-file-alt" style="color: gray; font-size: 20px;"></i>
                    <i v-else-if="(data.value === '5' || data.item.AllStatusOk == 'GRIS')" title="Not tested yet" class="fas fa-minus bg-secondary text-white"
                       style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                    <p v-else>{{ data.value }}</p>
                  </template>

                  <template #cell(criticity)="data">
                    <p v-if="data.value === '1'">{{ $t('injection_tab.criticityLevel.low') }}</p>
                    <p v-else-if="data.value === '2'">{{ $t('injection_tab.criticityLevel.medium') }}</p>
                    <p v-else-if="data.value === '3'">{{ $t('injection_tab.criticityLevel.high') }}</p>
                    <p v-else-if="data.value === '4'">{{ $t('injection_tab.criticityLevel.critical') }}</p>
                  </template>

                  <template #cell(datasetNumber)="data">
                    <p>{{ data.item.nbDatasets }}</p>
                  </template>

                  <template #cell(lastExecution)="data">
                    <p>{{ data.value | formatDateTime }}</p>
                  </template>

                  <template #cell(action)="data">
                    <b-button class="btnExecute mx-2 px-2 py-1 w-auto" variant="primary" @click="runTestCase(data.item)" :disabled="hasRightExecution()">{{ $t('injection_tab.send') }}</b-button>
                  </template>
                </b-table>
              </b-row>
              <b-row class="pb-3 justify-content-center" v-else>
                <p><strong>{{ $t('injection_tab.no_result_test_case') }}</strong></p>
              </b-row>
              <b-row class="pb-3 justify-content-center">
                <cm-pagination
                  @reset="resetSelectAll"
                  :maxResultsByPage="paginationObject.maxResults"
                  :firstIndex="paginationObject.firstIndex"
                  :nbResultsTotal="paginationObject.nbResultsTotal"
                  :refreshEvent="paginationObject.refresh">
                </cm-pagination>
              </b-row>
              <b-row class="pb-3 justify-content-center" v-if="testsCasesFiltered.length > 0">
                <b-button v-if="!this.hasRightExecution()" class="btnExecute mx-2 px-2 py-1 w-auto" variant="primary" @click="runTestsCases()">{{ $t('injection_tab.execute_selected_cases') }}</b-button>
                <b-button v-if="!this.hasRightExecution()" class="btnFilter mx-2 px-2 py-1 w-auto"
                          @click="runAllTest()">
                  <i class="fa-light fa-repeat fs-14px"></i>
                  {{ $t('common.run_all_test') }}
                </b-button>
                <!-- <b-button class="btnInitResult mx-2 px-2 py-1 w-auto" variant="secondary" @click="initResultTestStatus()">{{ $t('injection_tab.init_result_test_status') }}</b-button> -->
              </b-row>
            </div>
          </div>
        </b-container>
      </div>
    </template>
  </page-outline>
</template>

<script>

import _ from 'lodash'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue';

import dateTimePicker from '@/components/common/dateTimePicker.vue'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import moment from 'moment'
import {downloadFileWithDefinedHeaders} from "@/helpers/download";
import inputFilterDropDownList from "@/pages/toolbox/InputFilterDropDownList.vue";

export default {
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'input-filter-dropdown-list': inputFilterDropDownList,
    'form-accordion': FormAccordion,
    PageOutline,
    'datetime-picker-custom': dateTimePicker,
    'cm-pagination': Pagination,
    'spinner': Spinner,
  },
  data () {
    return {
      activateSpinner: false,
      countTestsCases: 0,
      pageCounter: 0,
      paginationObject: {},
      datasetsAPI: [],
      testCase: null,
      filterForm: {
        testCaseResult: "",
        caseStatus: "",
        caseSummary: "",
        dateBegin: "",
        dateEnd: ""
      },
      filterBy: '',
      filterConditions: {},
      filterToggle: false,
      selectedTestsCases: [],
      selectAll: false,
      sortBy: '',
      sortDir: false,
      testCaseDetailsToggle: false,
      testsCasesFiltered: [],
      testsCases: [],
      updateDetailsPanel: false,
      updateListPanel: false,
      AllRowName: [],
      resetSignal: 0,
      isDropdownOpen: false,
      referenceTestInput: ''
    };
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Tracking',
    })

    this.paginationObject['firstIndex'] = 1;
    this.paginationObject['maxResults'] = 10;
    this.paginationObject['nbResultsTotal'] = 0;
    this.paginationObject.nbResults = 0;

    this.paginationObject.nbResultsTotal = this.countTestsCases;
    this.paginationObject.nbResults = this.testsCasesFiltered ? this.testsCasesFiltered.length : 0;

    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  computed: {
    fieldsHistoryTab () {
      let fieldsHistoryTab = [
        { key: 'testCaseStatus', class: 'text-center align-middle', sortable: false },
        { key: 'testCaseStatusCode', class: 'text-center align-middle', sortable: false },
        { key: 'executionDate', class: 'text-center align-middle', sortable: false },
        { key: 'buttons', class: 'text-center align-middle', sortable: false },
      ];
      return fieldsHistoryTab;
    },
    fieldsTestsCasesTab () {
      let fieldsTestsCasesTab = [
        { key: 'select', label: '', class: 'text-center align-middle', sortable: false },
        { key: 'id', label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false },
        { key: 'caseSummary', label: this.$i18n.t('injection_tab.case_summary'), class: 'text-center align-middle', sortable: false },
        { key: 'expectedResult', label: this.$i18n.t('injection_tab.expected_result'), class: 'text-center align-middle', sortable: false },
        { key: 'datasetNumber', label: this.$i18n.t('injection_tab.dataset_number'), class: 'text-center align-middle', sortable: false },
        { key: 'lastExecution', label: this.$i18n.t('injection_tab.test_case.date_last_test'), class: 'text-center align-middle', sortable: false },
        { key: 'AllStatusOk', label: this.$i18n.t('injection_tab.result_test'), class: 'text-center align-middle', sortable: false },
      ]
      if (!this.hasRightExecution()) {
        fieldsTestsCasesTab.push({ key: 'action', label: this.$i18n.t('injection_tab.action'), class: 'text-center align-middle', sortable: false })

      }
      return fieldsTestsCasesTab
    },
    testCaseDatasets () {
      return this.testCase.datasets
    },
    uniqueExpectedResults() {
      return ['MTCH','NMTC','CMTC','NOAP','FORMAT_ERROR','TIMESTAMP_INVALID','CLIENT_INCONSISTENT']
    }
  },
  methods: {
     resetSelectAll(){
      console.log('resetSelectAll')
      this.selectAll = false
    },
    updateVal(newVal) {
      this.filterForm.caseSummary = newVal
    },
    getDateDay (date){
      if(date == ''){
        return '-'
      }else{
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss')
      }
    },
    addDataset (testCase) {
      let newDataset = {};

      newDataset.id = String("tmp" + this.testCase.tmpDatasets.length + 1);
      newDataset.idTestCase = testCase.id;
      newDataset.idAccount = -1;
      newDataset.creationDate = moment().format('YYYY-MM-DDTHH:mm:ss');
      newDataset.descriptionCase = '';
      newDataset.editingDescription = false;
      newDataset.lastExecution = null;
      newDataset.AllStatusOk = '5';
      newDataset.datas = [];
      newDataset.history = [];

      testCase.datasetsRequirements.forEach((requirement) => {
        let newDatasetData = {};

        newDatasetData.id = -1;
        newDatasetData.idDataset = -1;
        newDatasetData.field = requirement.field;
        newDatasetData.fieldValue = '';
        newDatasetData.tmpFieldValue = '';
        newDatasetData.messageType = requirement.messageType;

        newDataset.datas.push(newDatasetData);
      });

      testCase.tmpDatasets.push(newDataset);

      this.updateDetailsPanel = !this.updateDetailsPanel
    },
    applyFilter () {
      this.paginationObject['firstIndex'] = 1;
      this.getTestsCases()
    },
    buildDatasetName (index, isNew) {
      if(isNew) {
          return this.$i18n.t('toolbox.dataset') + " " + String(this.testCase.datasets.length+index+1);
      }
      return this.$i18n.t('toolbox.dataset') + " " + String(index+1);
    },
    checkFieldRegex(dataset, requirements) {
      let isCorrect = true;
      let invalidFields = [];

      dataset.datas.forEach((data) => {
        requirements.forEach((requirement) => {
          if (data.field === requirement.field) {
            const regex = new RegExp(requirement.fieldRegex);
            if (data.tmpFieldValue && !regex.test(data.tmpFieldValue)) {
              isCorrect = false;
              invalidFields.push(requirement.field); // stocke le nom du champ incorrect
            }
          }
        });
      });

      if (!isCorrect) {
        const message = this.$t('toolbox.dataset_field_error')+` ${invalidFields.join(', ')}`;
        this.okMessageBox(message);
      }

      return isCorrect;
    },
    closeTestCaseDetails (testCase) {
      testCase.tmpDatasets = [];
      this.testCase = null;
      this.testCaseDetailsToggle = false;
    },
    deleteDataset (dataset) {
      if (dataset.id.includes('tmp')) {
        this.testCase.tmpDatasets.splice(this.testCase.tmpDatasets.findIndex(obj => obj.id === dataset.id), 1)
        this.testCase = _.cloneDeep(this.testCase)
      } else {
        let that = this
        this.$engine.injectionTB.deleteDatasetAPI(dataset.id)
        .then(resp => {
          that.getDatasets()
        })
        .catch(error => {
          errorMessageAlert(error, that);
        })
      }
    },
    downloadHistory (history) {

    },
    editDatasetDescription (dataset) {
      dataset.editingDescription = !dataset.editingDescription;

      this.updateDetailsPanel = !this.updateDetailsPanel
    },
    fieldsDatasetRequirements (datasetRequirements) {
      let fields = []
      datasetRequirements.forEach(requirement => {
        switch (requirement.field) {
          case 'IBAN':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'NAME':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'RESPONDING_BICFI':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'REQUESTING_BICFI':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'USTRD_INFO':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'LEI':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'BIC':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'IDENTIFICATION':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'SCHEME_NAME_CODE':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'SCHEME_NAME_PROPRIETARY':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'ISSUER':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'X_REQUEST_ID':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'X_REQUEST_TIMESTAMP':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'CONTENT_TYPE':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'ACCEPT_HEADER':
            fields.push({ key: requirement.field, label: this.$i18n.t('account_tb.id'), class: 'text-center align-middle', sortable: false })
            break;
          case 'MATCHED_NAME':
            // bah non c'est pour resp ça
            break;
          default:

        }
      })
      return fields
    },
    formatDateForDatabase (dateStr) {
      if (!dateStr) return "";
      const [datePart, timePart] = dateStr.split(" ");
      const [day, month, year] = datePart.split("/");
      return `${year}-${month}-${day} ${timePart}`;
    },
    formatLastExecution (dt) {
      return dt ? moment(dt).format('YYYY-MM-DD hh:mm:ss') : '-'
    },
    getDatasets () {
      let that = this
      let filterConditions = {
        IdAccountTB: that.id,
        idTestCase: that.testCase.id
      }
      that.activateSpinner = true;
      that.$engine.injectionTB.getDatasetsAPI(filterConditions)
      .then(resp => {
        if (resp.data && resp.data.datasets && resp.data.datasets.length) {
          let datasets = [];
          resp.data.datasets.forEach(dataset => {

            dataset.editingDescription = false;
            dataset.lastExecution = null;
            dataset.AllStatusOk = '5';

            dataset.datas.forEach(data => {
              data.tmpFieldValue = data.fieldValue;
            });

            dataset.history.forEach(hist => {
              hist.executionDate = hist.executionDate.replace("T", " ");
              that.getLastExecutionDateAndStatus(dataset, hist.executionDate, hist.testCaseStatus);
            });

            datasets.push(dataset);
          });
          const addMissingRequirements = (datasetList) => {
            datasetList.forEach(dataset => {
              that.testCase.datasetsRequirements.forEach(requirement => {
                const exists = dataset.datas.some(data =>
                  data.field === requirement.field && data.messageType === requirement.messageType
                );

                if (!exists) {
                  dataset.datas.push({
                    id: -1,
                    idDataset: dataset.id,
                    field: requirement.field,
                    fieldValue: '',
                    tmpFieldValue: '',
                    messageType: requirement.messageType
                  });
                }
              });
            });
          };
          addMissingRequirements(that.testCase.datasets);

          that.testCase.datasets = datasets
          that.testCase = _.cloneDeep(that.testCase)
        }
        that.activateSpinner = false;
      })
      .catch(error => {
        that.activateSpinner = false;
        errorMessageAlert(error, that);
      })
    },
    runAllTest() {

      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      this.AllRowName = [];
      this.loading = true;
      const that = this;

      const filterConditions = {
        IdAccountTB: that.id,
        testcaseStatus: this.filterForm.caseStatus,
        expectedResult: this.filterForm.testCaseResult,
        caseSummary: this.filterForm.caseSummary,
        dateBegin: this.filterForm.dateBegin ? moment(this.filterForm.dateBegin).utc().format('YYYY-MM-DDTHH:mm:ss.000Z') : '',
        dateEnd: this.filterForm.dateEnd ? moment(this.filterForm.dateEnd).utc().format('YYYY-MM-DDTHH:mm:ss.999Z') : ''
      };

      that.$engine.injectionTB.getTestsCasesAPI(filterConditions)
          .then(resp => {
            if (resp.data && resp.data.testsCases) {
              that.testsCases = resp.data.testsCases;

              // Préparation des promesses pour chaque test
              const testPromises = that.testsCases.map(testCase => {
                testCase.lastExecution = null;
                testCase.tmpDatasets = [];
                testCase.datasets = [];
                testCase.lastExecution = testCase.lastExecDate;
                testCase.datasetsRequirementsRequest = [];
                testCase.datasetsRequirementsResponse = [];

                testCase.datasetsRequirements.forEach(requirement => {
                  if (requirement.messageType === '0') {
                    testCase.datasetsRequirementsRequest.push(requirement);
                  } else {
                    testCase.datasetsRequirementsResponse.push(requirement);
                  }
                });

                // Retourne la promesse de l'exécution du test
                return that.runTestCase(testCase);
              });


              // Exécute tous les tests en parallèle
              Promise.all(testPromises)
                  .then(() => {
                    // Rafraîchit les données après l'exécution des tests
                    return that.getTestsCases();
                  })
                  .then(() => {
                    that.$f7.alert('', that.$i18n.t('common.all_test_execut'))
                  })
                  .catch(error => {
                    that.loading = false;
                    errorMessageAlert(error, that);
                  });
            } else {
              that.loading = false;
              that.$f7.alert('', that.$i18n.t('common.all_test_execut_error'))
            }

            if (resp.data && resp.data.AllTestCaseName) {
              let result = [];
              if (!Array.isArray(resp.data.AllTestCaseName))
                result.push(resp.data.AllTestCaseName);
              else {
                result = resp.data.AllTestCaseName;
              }
              result.forEach(rowName => {
                this.AllRowName.push(rowName["~Unknown_2"]);
              });
            }

            that.testsCasesFiltered = that.testsCases;
            this.updateListPanel = !this.updateListPanel;
          })
          .catch(error => {
            that.loading = false;
            this.updateListPanel = !this.updateListPanel;
            errorMessageAlert(error, that);
          });

      this.updateListPanel = !this.updateListPanel;
      this.$f7.hidePreloader()
    },
    getTestsCases () {
      this.AllRowName = []
      let that = this;

      that.activateSpinner = true;
      let filterConditions = {
        IdAccountTB: that.id,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        testcaseStatus: this.filterForm.caseStatus,
        expectedResult: this.filterForm.testCaseResult,
        caseSummary: this.filterForm.caseSummary,
        dateBegin: this.filterForm.dateBegin ? moment(this.filterForm.dateBegin).utc().format('YYYY-MM-DDTHH:mm:ss.000Z') : '',
        dateEnd: this.filterForm.dateEnd ? moment(this.filterForm.dateEnd).utc().format('YYYY-MM-DDTHH:mm:ss.999Z') : ''
      }

      that.$engine.injectionTB.getTestsCasesAPI(filterConditions)
      .then(resp => {
        if (resp.data && resp.data.testsCases) {
          that.testsCases = resp.data.testsCases;
          that.testsCases.forEach(testCase => {
            testCase.lastExecution = null;
            testCase.tmpDatasets = [];
            testCase.datasets = []
            testCase.lastExecution = testCase.lastExecDate
            testCase.datasetsRequirementsRequest = [];
            testCase.datasetsRequirementsResponse = [];

            testCase.datasetsRequirements.forEach(requirement => {
              if (requirement.messageType === '0') {
                testCase.datasetsRequirementsRequest.push(requirement);
              }
              else {
                testCase.datasetsRequirementsResponse.push(requirement);
              }
            });
          });
        }
        if (resp.data && resp.data.countTestsCases) {
          that.countTestsCases = resp.data.countTestsCases;
          this.paginationObject.nbResults = resp.data.testsCases.length;
          this.paginationObject.nbResultsTotal = resp.data.countTestsCases
        }


        if(resp.data.AllTestCaseName){
          let result = []
          if(!Array.isArray(resp.data.AllTestCaseName))
            result.push(resp.data.AllTestCaseName)
          else {
            result = resp.data.AllTestCaseName
          }
          result.forEach(rowName => {
            this.AllRowName.push(rowName["~Unknown_2"])
          })
        }

        that.testsCasesFiltered = that.testsCases;
        that.activateSpinner = false;
        this.updateListPanel = !this.updateListPanel;
      })
      .catch(error => {
        that.activateSpinner = false;
        this.updateListPanel = !this.updateListPanel;
        errorMessageAlert(error, that);
      })

      this.updateListPanel = !this.updateListPanel;
    },
    getLastExecutionDateAndStatus (item, executionDate, status) {
      if(!item.lastExecution || moment(item.lastExecution) < moment(executionDate)) {
        item.lastExecution = executionDate;
        item.AllStatusOk = status;
      }
    },
    isCSV (file) {
      const validMimeTypes = ['text/csv', 'application/vnd.ms-excel']
      const extension = file.name.split('.').pop().toLowerCase()
      return validMimeTypes.includes(file.type) && extension === 'csv'
    },
    isCSVContent (content) {
      const lines = content.trim().split('\n')

      const delimiter = content.includes(';') ? ';' : ','
      const firstLineColumns = lines[0].split(delimiter).length

      return lines.every(line => line.split(delimiter).length === firstLineColumns)
    },
    parseCSV(csvContent) {
      const lines = csvContent.trim().split('\r\n')
      const delimiter = csvContent.includes(';') ? ';' : ','
      let request = {}
      let that = this;
      const headers = lines[0].split(delimiter);
      const unknown_header = []
      let foundID = false;
      let foundDESC = false;
      headers.forEach(header => {
        if(!this.validHeader(header))
          unknown_header.push(header)
        if(header === "ID_TEST_CASE")
          foundID = true;
        if(header === "DESCRIPTION")
          foundDESC = true;
      })
      if(unknown_header.length > 0) {
        this.okMessageBox(this.$t('toolbox.import_error_unknown_header'))
        return
      }
      if(!foundID || !foundDESC) {
        this.okMessageBox(this.$t('toolbox.import_error_obligatory_field_not_found'))
        return
      }
      request.csv_delimiter = delimiter
      request.csv_content = []
      lines.forEach(lineContent => {
        const content = lineContent.split(delimiter)
        if(content !== undefined && content.length > 0)
          request.csv_content.push(lineContent)
      })
      if(request.csv_content.length === 1) {
        this.okMessageBox(this.$t('toolbox.import_empty_csv'))
        return
      }
      request.action = "CSV";
      request.idAccount = this.$engine.user.get().id;

      this.$engine.injectionTB.postDatasetAPI({}, request)
          .then(resp => {
            if(resp.data.error)
              this.okMessageBox(this.$t('toolbox.import_content_error'))
            else
              that.getTestsCases()
          })
          .catch(error => {
            errorMessageAlert(error, that);
          })
    },
    async importTestCases (event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      let validCSV = true;
      reader.onload = async (e) => {
        const csvContent = e.target.result;
        validCSV = validCSV && this.isCSV(file) && this.isCSVContent(csvContent)
        if (validCSV)
          this.parseCSV(csvContent)
        else
          this.okMessageBox(this.$t('toolbox.import_error_format'))
      }
      reader.readAsText(file);
    },
    validHeader(header){
      switch (header){
        case 'ID_TEST_CASE' :
        case 'DESCRIPTION' :
        case 'IBAN' :
        case 'NAME' :
        case 'RESPONDING_BICFI' :
        case 'REQUESTING_BICFI' :
        case 'USTRD_INFO' :
        case 'LEI' :
        case 'BIC' :
        case 'IDENTIFICATION' :
        case 'SCHEME_NAME_CODE' :
        case 'SCHEME_NAME_PROPRIETARY' :
        case 'ISSUER' :
        case 'X_REQUEST_ID' :
        case 'X_REQUEST_TIMESTAMP' :
        case 'CONTENT_TYPE' :
        case 'ACCEPT_HEADER' :
        case 'MATCHED_NAME' :
        case 'USTRD_INFO_2' :
          return true
        default:
          return false
      }
    },
    initResultTestStatus () {
      let that = this;

      that.testsCases.forEach(testCase => {
        testCase.AllStatusOk = '5';
      });
      that.testsCasesFiltered.forEach(testCase => {
        testCase.AllStatusOk = '5';
      });
    },
    itemsDatasetRequirements (datasetRequirements) {
      return []
    },
    onRefresh (noAttach = false, index = 1) {
      this.updateListPanel = !this.updateListPanel;

      let that = this;
      that.pageCounter = 0;
      that.paginationObject['firstIndex'] = index;

      this.getTestsCases();

      that.paginationObject['nbResultsTotal'] = this.countTestsCases;
      that.paginationObject.nbResults = that.testsCasesFiltered.length;
      that.$f7.pullToRefreshDone()
      that.$bus.emit('refresh-cache-paging-template', that.paginationObject)

      this.updateListPanel = !this.updateListPanel;

    },
    openHistory (IdMsg, status, action,  service = 'historyDataSet') {
      let that = this
      const id = IdMsg
      let dataDetails = {}
      this.$engine.tracking.getJSON({service, id, status})
          .then((resp) => {
            if (resp.data) {
              dataDetails.data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
              dataDetails.type = service
              if (action === 'see') {
                that.$bus.emit('popup-json-details', dataDetails)
              } else {
                let data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
                  const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.txt'
                  const blob = new Blob([data], { type: 'text/plain' })

                  downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
                  that.$f7.alert('', that.$i18n.t('common.txt_downloaded'))

              }
            }
          })
          .catch((error) => {
            errorMessageAlert(error, that)
          })
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    openTestCaseDetails (testCase) {
      this.testCase = testCase;
      this.testCaseDetailsToggle = true;
      this.getDatasets()
    },
    parseHistoryDate (dateStr) {
      return moment.utc(dateStr).local().format('YYYY-MM-DD HH:mm:ss.SSS')
    },
    postDataset (dataset, testCase, index) {
      let that = this;

      if (that.checkFieldRegex(dataset, testCase.datasetsRequirements)) {
        let filterConditions = {
          IdAccountTB: that.id
        };

        let nbDataInserted = 0;

        let datasetToSend = {
          id: dataset.id,
          idTestCase: dataset.idTestCase,
          idAccount: dataset.idAccount,
          creationDate: dataset.creationDate.replace(" ", "T"),
          descriptionCase: dataset.descriptionCase,
          data: dataset.datas.map(data => {
            return {
              id: data.id,
              idDataset: data.idDataset,
              field: data.field,
              fieldValue: data.tmpFieldValue,
              messageType: data.messageType,
              regexVerif: testCase.datasetsRequirements.find(requirement => requirement.field === data.field) ? testCase.datasetsRequirements.find(requirement => requirement.field === data.field).fieldRegex : ''
            }
          })
        }
        that.$engine.injectionTB.postDatasetAPI(filterConditions, datasetToSend)
        .then(resp => {
          if (resp.data) {
            that.getDatasets()
            testCase.tmpDatasets.splice(index, 1)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
      }
    },
    putDataset (dataset, testCase) {
      let that = this;

      if(that.checkFieldRegex(dataset, testCase.datasetsRequirements)) {
        let filterConditions = {
          IdAccountTB: that.id
        }

        dataset.datas.forEach((data) => {
          let datasetToSend = {
            id: dataset.id,
            idTestCase: dataset.idTestCase,
            idAccount: dataset.idAccount,
            creationDate: dataset.creationDate,
            descriptionCase: dataset.descriptionCase,
            data: {
              id: data.id,
              idDataset: data.idDataset,
              field: data.field,
              fieldValue: data.tmpFieldValue,
              messageType: data.messageType,
              regexVerif: testCase.datasetsRequirements.find(requirement => requirement.field === data.field) ? testCase.datasetsRequirements.find(requirement => requirement.field === data.field).fieldRegex : ''
            }
          }

          that.$engine.injectionTB.putDatasetAPI(filterConditions, datasetToSend)
          .then(resp => {
            if (resp.data) {
              data.id = resp.data.IdRespDatasetData;
            }
            data.fieldValue = datasetToSend.data.tmpFieldValue;
          })
          .catch(error => {
            errorMessageAlert(error, that);
          })
        });
      }
    },
    refreshDetails (testCase) {
      let that = this
      let filterConditions = {
        testcaseStatus: testCase.testCaseResult,
        expectedResult: testCase.expectedResult,
        caseSummary: testCase.caseSummary
      }
      that.$engine.injectionTB.getTestsCasesAPI(filterConditions)
      .then(resp => {
        if (resp.data && resp.data.testsCases) {
          resp.data.testsCases.forEach(testCaseResp => {
            if (testCaseResp.id === testCase.id) {
              testCaseResp.tmpDatasets = [];
              testCaseResp.datasets = []
              testCaseResp.lastExecution = testCase.lastExecDate
              testCaseResp.datasetsRequirementsRequest = [];
              testCaseResp.datasetsRequirementsResponse = [];

              testCaseResp.datasetsRequirements.forEach(requirement => {
                if (requirement.messageType === '0') {
                  testCaseResp.datasetsRequirementsRequest.push(requirement);
                }
                else {
                  testCaseResp.datasetsRequirementsResponse.push(requirement);
                }
              });
              that.testCase = _.cloneDeep(testCaseResp)
              this.getDatasets()

            }
          });
        }
        that.activateSpinner = false;
      })
      .catch(error => {
        that.activateSpinner = false;
        errorMessageAlert(error, that);
      })
    },
    reOrderBy (column) {
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.updateListPanel = !this.updateListPanel;
    },
    resetFilterForm () {
      this.filterForm.testCaseResult = "";
      this.filterForm.caseStatus = "";
      this.filterForm.caseSummary = "";
      this.filterForm.dateBegin = "";
      this.filterForm.dateEnd = "";
      this.resetSignal++
      this.applyFilter();
      this.updateListPanel = !this.updateListPanel;
    },
    hasRightExecution (){
      return this.$engine.rights.rightIs('ExecutionResponder_add', false)
    },
    runTestsCases () {
      this.selectedTestsCases.forEach((selectedTestCaseId) => {
        let selectedTestCase = this.testsCasesFiltered.find(testCase => testCase.id === selectedTestCaseId);
        this.runTestCase(selectedTestCase);
      });
    },
    runTestCase (testCase) {
      let that = this

      let filterConditions = {
        IdAccountTB: that.id
      };

      testCase.AllStatusOk = '4';
      testCase.lastExecution = moment().utc().format('YYYY-MM-DD HH:mm:ss');
      that.$engine.injectionTB.runTestCaseAPI(filterConditions, testCase.id)
      .then(resp => {
        if(resp) {
          if (resp.status === 200) {
            testCase.datasets.forEach(dataset => {
              dataset.lastExecution = testCase.lastExecution;
            });

            that.updateDetailsPanel = !that.updateDetailsPanel;
            that.updateListPanel = !that.updateListPanel;
          }
        }
      })
      .catch(error => {
        if (error && error.response && error.response.data && error.response.data.error) {
          switch(error.response.data.error) {
            case 'Toolbox_Responder-0':
              that.$f7.alert('', that.$t('injection_tab.run_error.toolbox_responder_0'))
              break
            case 'Toolbox_Responder-1':
              that.$f7.alert('', that.$t('injection_tab.run_error.toolbox_responder_1'))
              break
            case 'Toolbox_Responder-2':
              that.$f7.alert('', that.$t('injection_tab.run_error.toolbox_responder_2'))
              break
            default:
              errorMessageAlert(error, that);
          }
        } else {
          errorMessageAlert(error, that);
        }
        that.updateDetailsPanel = !that.updateDetailsPanel;
        that.updateListPanel = !that.updateListPanel;
      })
    },
    runDataset (dataset) {
      let that = this

      let filterConditions = {
        IdAccountTB: that.id
      };

      if (that.checkFieldRegex(dataset, that.testCase.datasetsRequirements)) {
        that.testCase.AllStatusOk = '4';
        dataset.AllStatusOk = '4';
        dataset.lastExecution = moment().format('YYYY-MM-DD HH:mm:ss');
        that.testCase.lastExecution = moment().format('YYYY-MM-DD HH:mm:ss');
        that.$engine.injectionTB.runDatasetAPI(filterConditions, dataset.id)
        .then(resp => {
          if(resp) {
            if (resp.status === 200) {
              dataset.AllStatusOk = '2';
              this.updateDetailsPanel = !this.updateDetailsPanel
            }
          }
          that.refreshDetails(that.testCase)
        })
        .catch(error => {
          if (error && error.response && error.response.data && error.response.data.error) {
            switch(error.response.data.error) {
              case 'Toolbox_Responder-0':
                that.$f7.alert('', that.$t('injection_tab.run_error.toolbox_responder_0'))
                break
              case 'Toolbox_Responder-1':
                that.$f7.alert('', that.$t('injection_tab.run_error.toolbox_responder_1'))
                break
              case 'Toolbox_Responder-2':
                that.$f7.alert('', that.$t('injection_tab.run_error.toolbox_responder_2'))
                break
              default:
                errorMessageAlert(error, that);
            }
          } else {
            errorMessageAlert(error, that);
          }
        })
      }
      else {
        dataset.AllStatusOk = '3';
        this.updateDetailsPanel = !this.updateDetailsPanel
      }
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = ['Name', 'Case summary', 'Status Header', 'Http code', 'Num. Req/Resp', 'Case Status', 'Last execution', 'Result Test'];

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection
      this.updateListPanel = !this.updateListPanel;
    },
    toggleAllRows() {
      if (this.selectAll) {
        this.selectedTestsCases = this.testsCasesFiltered.map(item => item.id);
      } else {
        this.selectedTestsCases = [];
      }
      this.updateListPanel = !this.updateListPanel;
    },
    toggleFilter() {
      this.filterToggle = !this.filterToggle;
      this.updateListPanel = !this.updateListPanel;
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
  }
};
</script>

<style scoped>
.checkbox-lg {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
  cursor: pointer;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
